import script from "./Account.vue?vue&type=script&setup=true&lang=js"
export * from "./Account.vue?vue&type=script&setup=true&lang=js"

import "./Account.vue?vue&type=style&index=0&id=a0dea870&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a0dea870"]])

export default __exports__